<template>
  <div>
    <!--提示语-->
    <div style="padding: 10px;color: #d9d9d9">{{ $t('CargoMsg.Cargo_OcrTip') }}</div>
    <div v-if="visible" class="result-form-ai">
      <div :style="{cursor:'pointer',width: '100%'}">
        <!--ocr识别字段-header-->
        <div class="row" style="position: relative;">
          <div class="item1" style="font-weight: bold;color: white;background-color: #3f3f3f">
            <span>{{ $t('CargoMsg.Cargo_FieldName') }}</span>
          </div>
          <span
            v-if="showBookRecognitionResults"
            style="position: absolute;left: 105px;top: 6px; padding: 2px;background-color: white;cursor: pointer"
            @click="showBookRecognitionResults=false"
          >{{ $t('CargoMsg.Cargo_PackUp') }}</span>
          <span
            v-else
            style="position: absolute;left: 165px;top: 6px; padding: 2px;background-color: white;cursor: pointer"
            @click="showBookRecognitionResults=true"
          >{{ $t('CargoMsg.Cargo_ExpandAll') }}</span>
          <div v-if="showBookRecognitionResults" class="item2" style="font-weight: bold;color: white;background-color: #3f3f3f">{{ $t('CargoMsg.Cargo_BookRecognitionResults') }}</div>
          <div class="item3" style="font-weight: bold;color: white;background-color: #abd08e">{{ $t('CargoMsg.Cargo_ConfirmedBusinessData') }}</div>
        </div>
        <!--ocr识别字段-content-->
        <div v-if="currentOcrRecognitionFields && currentOcrRecognitionFields.length > 0">
          <div v-for="item in currentOcrRecognitionFields" :key="item.code">
            <!--MAWB-->
            <div v-if="item.code === SystemConstants.MBL_NO.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ OcrUtils.getOcrFieldLabel(item.code, useCase) }}</div>
              <div v-if="showBookRecognitionResults" class="item2">{{ resultJson[item.code] }}</div>
              <div style="display: flex;justify-content: space-between" class="item3">
                <el-input v-model="job.mbl" class="item3" :style="{ borderColor: getValueBorderColor(item) }" />
              </div>
            </div>
            <!--分单号-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_HBL.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ OcrUtils.getOcrFieldLabel(item.code, useCase) }}</div>
              <div v-if="showBookRecognitionResults" class="item2">{{ resultJson[item.code] }}</div>
              <div style="display: flex;justify-content: space-between" class="item3">
                <el-input v-model="job.hbl" class="item3" :style="{ borderColor: getValueBorderColor(item) }" />
              </div>
            </div>
            <!--操作模式-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_OPERATE_TYPE.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ OcrUtils.getOcrFieldLabel(item.code, useCase) }}</div>
              <div v-if="showBookRecognitionResults" class="item2">{{ resultJson[item.code] }}</div>
              <cargo-advance-select
                class="item3"
                :style="{ borderColor: getValueBorderColor(item) }"
                no="operateType"
                filterable
                :select-type="selectTypeNames.local_cache_ImportConstants$_cargoTypeAirInputList"
                callback-method-type="value"
                :default-value="job.operateType"
                :callback-params="{key:'operateType'}"
                clearable
                @parentCallBack="setJobSelectValue"
              />
            </div>
            <!--委托单位-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_CUSTOMER_ID.code" class="row" @click="handleFocus(item.code)">
              <div
                class="item1"
                :style="{ color: getFieldColor(item) }"
              >{{ OcrUtils.getOcrFieldLabel(item.code, useCase) }}</div>
              <div v-if="showBookRecognitionResults" class="item2">{{ resultJson[item.code] }}</div>
              <cargo-company-select
                class="item3"
                :style="{ borderColor: getValueBorderColor(item) }"
                :method-params="{customer:true,companyLob:'airImport',active:true}"
                :default-value="job.customerId||''"
                :placeholder="!job.customerId && resultJson[item.code] && !resultJson[item.code + '_notShowPlaceholder'] ? resultJson[item.code] : ''"
                :class="!job.customerId && resultJson[item.code] && !resultJson[item.code + '_notShowPlaceholder'] ? 'color-red' : ''"
                @clear="clear(item)"
                @change="p=>{job.customerId=p.value}"
              />
            </div>
            <!--发货人-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_SHIPPER.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ OcrUtils.getOcrFieldLabel(item.code, useCase) }}</div>
              <el-input v-if="showBookRecognitionResults" v-model="resultJson[item.code]" disabled :rows="6" type="textarea" class="item2" />
              <el-input v-model="job.shipper" :rows="6" type="textarea" class="item3" :style="{ borderColor: getValueBorderColor(item) }" />
            </div>
            <!--收货人-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_CONSIGNEE.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ OcrUtils.getOcrFieldLabel(item.code, useCase) }}</div>
              <el-input v-if="showBookRecognitionResults" v-model="resultJson[item.code]" disabled :rows="6" type="textarea" class="item2" />
              <el-input v-model="job.consignee" :rows="6" type="textarea" class="item3" :style="{ borderColor: getValueBorderColor(item) }" />
            </div>
            <!--通知人-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_NOTIFY.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ OcrUtils.getOcrFieldLabel(item.code, useCase) }}</div>
              <el-input v-if="showBookRecognitionResults" v-model="resultJson[item.code]" disabled :rows="6" type="textarea" class="item2" />
              <el-input v-model="job.notify" :rows="6" type="textarea" class="item3" :style="{ borderColor: getValueBorderColor(item) }" />
            </div>
            <!--Issued By-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_ISSUED_BY.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ OcrUtils.getOcrFieldLabel(item.code, useCase) }}</div>
              <el-input v-if="showBookRecognitionResults" v-model="resultJson[item.code]" disabled :rows="6" type="textarea" class="item2" />
              <el-input v-model="job.airCargoDoc[0].issuedBy" :rows="6" type="textarea" class="item3" :style="{ borderColor: getValueBorderColor(item) }" />
            </div>
            <!--Accounting Information-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_ACCOUNTING_INFO.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ OcrUtils.getOcrFieldLabel(item.code, useCase) }}</div>
              <el-input v-if="showBookRecognitionResults" v-model="resultJson[item.code]" disabled :rows="6" type="textarea" class="item2" />
              <el-input v-model="job.airCargoDoc[0].accountingInfo" :rows="6" type="textarea" class="item3" :style="{ borderColor: getValueBorderColor(item) }" />
            </div>
            <!--航空公司-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_CARRIER.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ OcrUtils.getOcrFieldLabel(item.code, useCase) }}</div>
              <div v-if="showBookRecognitionResults" class="item2">{{ resultJson[item.code] }}</div>
              <cargo-advance-select
                no="41"
                filterable
                class="item3"
                :style="{ borderColor: getValueBorderColor(item) }"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{airCmp:true, companyLob:'airImport',active:true}"
                :default-value="job.carrierId||''"
                :headers="[$t('Tool.ShortName'),$t('Partners.chineseName')]"
                :fields="['shortName', 'chineseName']"
                :placeholder="!job.carrierId && resultJson[item.code] && !resultJson[item.code + '_notShowPlaceholder'] ? resultJson[item.code] : ''"
                :class="!job.carrierId && resultJson[item.code] && !resultJson[item.code + '_notShowPlaceholder'] ? 'color-red' : ''"
                @clear="clear(item)"
                @parentCallBack="p => {job.carrierId=p.value}"
              />
            </div>
            <!--航班号-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_VOYAGE.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ OcrUtils.getOcrFieldLabel(item.code, useCase) }}</div>
              <div v-if="showBookRecognitionResults" class="item2">{{ resultJson[item.code] }}</div>
              <div style="display: flex;justify-content: space-between" class="item3">
                <el-input v-model="job.voyageFlight" class="item3" :style="{ borderColor: getValueBorderColor(item) }" @change="voyageFlightCheckHandler" />
              </div>
            </div>
            <!--开航日期-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_ETD.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ OcrUtils.getOcrFieldLabel(item.code, useCase) }}</div>
              <div v-if="showBookRecognitionResults" class="item2">{{ resultJson[item.code] }}</div>
              <el-date-picker
                class="item3"
                :style="{ borderColor: getValueBorderColor(item) }"
                :value="job.etd"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm"
                format="yyyy-MM-dd HH:mm"
                @input="etdChange"
              />
            </div>
            <!--运费条款-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_PAYMENT_TERM.code" class="row" @click="handleFocus(item.code)">
              <div style="display: block; width:100%">
                <div style="display: flex">
                  <div class="item1" :style="{ color: getFieldColor(item) }">{{ OcrUtils.getOcrFieldLabel(item.code, useCase) }}</div>
                  <div v-if="showBookRecognitionResults" class="item2">{{ resultJson[item.code] }}</div>
                  <cargo-advance-select
                    class="item3"
                    :style="{ borderColor: getValueBorderColor(item) }"
                    :select-type="selectTypeNames.basic_data_PaymentTerm"
                    filterable
                    clearable
                    :default-value="job.paymentTermMBL"
                    :placeholder="!job.paymentTermMBL && resultJson[item.code] && !resultJson[item.code + '_notShowPlaceholder'] ? resultJson[item.code] : ''"
                    :class="!job.paymentTermMBL && resultJson[item.code] && !resultJson[item.code + '_notShowPlaceholder'] ? 'color-red' : ''"
                    @clear="clear(item)"
                    @parentCallBack="p=>{job.paymentTermMBL=p.value;}"
                  />
                </div>
              </div>
            </div>
            <!--贸易条款-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_INCO_TERM.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ OcrUtils.getOcrFieldLabel(item.code, useCase) }}</div>
              <div v-if="showBookRecognitionResults" class="item2">{{ resultJson[item.code] }}</div>
              <cargo-advance-select
                class="item3"
                :style="{ borderColor: getValueBorderColor(item) }"
                no="incoTerm"
                :select-type="selectTypeNames.basic_data_IncoTerm"
                filterable
                clearable
                :default-value="job.incoTerm"
                :placeholder="!job.incoTerm && resultJson[item.code] && !resultJson[item.code + '_notShowPlaceholder'] ? resultJson[item.code] : ''"
                :class="!job.incoTerm && resultJson[item.code] && !resultJson[item.code + '_notShowPlaceholder'] ? 'color-red' : ''"
                @clear="clear(item)"
                @parentCallBack="p=>{job.incoTerm=p.value}"
              />
            </div>
            <!--签发日期-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_SIGN_DATE_BL.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ OcrUtils.getOcrFieldLabel(item.code, useCase) }}</div>
              <div v-if="showBookRecognitionResults" class="item2">{{ resultJson[item.code] }}</div>
              <el-date-picker
                v-model="job.airCargoDoc[0].signDateBL"
                class="item3"
                :style="{ borderColor: getValueBorderColor(item) }"
                clearable
                type="date"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
              />
            </div>
            <!--签发地点-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_SIGN_PLACE_BL.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ OcrUtils.getOcrFieldLabel(item.code, useCase) }}</div>
              <div v-if="showBookRecognitionResults" class="item2">{{ resultJson[item.code] }}</div>
              <div style="display: flex;justify-content: space-between" class="item3">
                <el-input v-model="job.airCargoDoc[0].signPlaceBL" class="item3" :style="{ borderColor: getValueBorderColor(item) }" />
              </div>
            </div>
            <!--起始站-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_LOADING_PORT_CODE.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ OcrUtils.getOcrFieldLabel(item.code, useCase) }}</div>
              <div v-if="showBookRecognitionResults" class="item2">{{ resultJson[item.code] }}</div>
              <cargo-advance-select
                class="item3"
                :style="{ borderColor: getValueBorderColor(item) }"
                no="englishName"
                :select-type="selectTypeNames.basic_data_Airport"
                filterable
                :default-value="job.loadingPortCode"
                tag-name="englishName"
                :placeholder="!job.loadingPortCode && resultJson[item.code] && !resultJson[item.code + '_notShowPlaceholder'] ? resultJson[item.code] : ''"
                :class="!job.loadingPortCode && resultJson[item.code] && !resultJson[item.code + '_notShowPlaceholder'] ? 'color-red' : ''"
                @clear="clear(item)"
                @parentCallBack="p=>{job.loadingPortCode=p.value;}"
              />
            </div>
            <!--目的站-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_DISCHARGING_PORT_CODE.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ OcrUtils.getOcrFieldLabel(item.code, useCase) }}</div>
              <div v-if="showBookRecognitionResults" class="item2">{{ resultJson[item.code] }}</div>
              <cargo-advance-select
                class="item3"
                :style="{ borderColor: getValueBorderColor(item) }"
                no="dischargingPortCode"
                :select-type="selectTypeNames.basic_data_Airport"
                filterable
                :default-value="job.dischargingPortCode"
                :placeholder="!job.dischargingPortCode && resultJson[item.code] && !resultJson[item.code + '_notShowPlaceholder'] ? resultJson[item.code] : ''"
                :class="!job.dischargingPortCode && resultJson[item.code] && !resultJson[item.code + '_notShowPlaceholder'] ? 'color-red' : ''"
                @clear="clear(item)"
                @parentCallBack="p=>{job.dischargingPortCode=p.value}"
              />
            </div>
            <!--件数-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_QUANTITY_ACTUAL.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ OcrUtils.getOcrFieldLabel(item.code, useCase) }}</div>
              <div v-if="showBookRecognitionResults" class="item2">{{ resultJson[item.code] }}</div>
              <el-input-number v-model="job.quantityActual" :controls="false" class="item3" :style="{ borderColor: getValueBorderColor(item), textAlign: 'left' }" no="quantityContract" />
            </div>
            <!--包装-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_PACKING.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ OcrUtils.getOcrFieldLabel(item.code, useCase) }}</div>
              <div v-if="showBookRecognitionResults" class="item2">{{ resultJson[item.code] }}</div>
              <cargo-packing-select
                no="packing"
                class="item3"
                :style="{ borderColor: getValueBorderColor(item) }"
                :default-value="job.packing"
                :placeholder="!job.packing && resultJson[item.code] && !resultJson[item.code + '_notShowPlaceholder'] ? resultJson[item.code] : ''"
                :class="!job.packing && resultJson[item.code] && !resultJson[item.code + '_notShowPlaceholder'] ? 'color-red' : ''"
                @clear="clear(item)"
                @change="p=>{job.packing=p.value;}"
              />
            </div>
            <!--毛重-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_WEIGHT_ACTUAL.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ OcrUtils.getOcrFieldLabel(item.code, useCase) }}</div>
              <div v-if="showBookRecognitionResults" class="item2">{{ resultJson[item.code] }}</div>
              <el-input-number v-model="job.weightActual" :precision="3" :controls="false" class="item3" :style="{ borderColor: getValueBorderColor(item), textAlign: 'left' }" no="weightContract" />
            </div>
            <!--KG-LB-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_KGLB.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ OcrUtils.getOcrFieldLabel(item.code, useCase) }}</div>
              <div v-if="showBookRecognitionResults" class="item2">{{ resultJson[item.code] }}</div>
              <el-select v-model="job.airCargoDoc[0].kglb" class="item3" no="kglb" :style="{ borderColor: getValueBorderColor(item) }">
                <el-option label="K" value="K" />
                <el-option label="L" value="L" />
              </el-select>
            </div>
            <!--体积-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_CUBAGE_ACTUAL.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ OcrUtils.getOcrFieldLabel(item.code, useCase) }}</div>
              <div v-if="showBookRecognitionResults" class="item2">{{ resultJson[item.code] }}</div>
              <el-input-number v-model="job.cubageActual" :precision="3" :controls="false" class="item3" :style="{ borderColor: getValueBorderColor(item), textAlign: 'left' }" no="cubageContract" />
            </div>
            <!--唛头-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_MARK.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ OcrUtils.getOcrFieldLabel(item.code, useCase) }}</div>
              <!--            <div class="item2" v-if="showBookRecognitionResults">{{ resultJson[item.code] }}</div>-->
              <el-input v-if="showBookRecognitionResults" v-model="resultJson[item.code]" disabled :rows="6" type="textarea" class="item2" />
              <el-input v-model="job.mark" :rows="6" type="textarea" class="item3" :style="{ borderColor: getValueBorderColor(item) }" no="mark" />
            </div>
            <!--品名-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_GOOD_NAME.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ OcrUtils.getOcrFieldLabel(item.code, useCase) }}</div>
              <!--            <div class="item2" v-if="showBookRecognitionResults">{{ resultJson[item.code] }}</div>-->
              <el-input v-if="showBookRecognitionResults" v-model="resultJson[item.code]" disabled :rows="6" type="textarea" class="item2" />
              <el-input v-model="job.cargoEnglishName" :rows="6" type="textarea" :style="{borderColor: getValueBorderColor(item)}" class="item3" no="cargoEnglishName" />
            </div>
            <!--声明价值-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_CARRIAGE_DV.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ OcrUtils.getOcrFieldLabel(item.code, useCase) }}</div>
              <div v-if="showBookRecognitionResults" class="item2">{{ resultJson[item.code] }}</div>
              <div style="display: flex;justify-content: space-between" class="item3">
                <el-input v-model="job.airCargoDoc[0].carriageDv" class="item3" :style="{ borderColor: getValueBorderColor(item) }" />
              </div>
            </div>
            <!--海关声明价值-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_DVFOR_CUSTOMS.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ OcrUtils.getOcrFieldLabel(item.code, useCase) }}</div>
              <div v-if="showBookRecognitionResults" class="item2">{{ resultJson[item.code] }}</div>
              <div style="display: flex;justify-content: space-between" class="item3">
                <el-input v-model="job.airCargoDoc[0].dvForCustoms" class="item3" :style="{ borderColor: getValueBorderColor(item) }" />
              </div>
            </div>
            <!--费率等级-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_RATE_CLASS.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ OcrUtils.getOcrFieldLabel(item.code, useCase) }}</div>
              <div v-if="showBookRecognitionResults" class="item2">{{ resultJson[item.code] }}</div>
              <el-select v-model="job.airCargoDoc[0].rateClass" no="rateClass" class="item3" :style="{ borderColor: getValueBorderColor(item) }">
                <el-option v-for="item in AirExportConstants.RATE_CLASSES" :key="item" :label="item" :value="item" />
              </el-select>
            </div>
            <!--计费重量-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_CHARGEWEIGHT.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ OcrUtils.getOcrFieldLabel(item.code, useCase) }}</div>
              <div v-if="showBookRecognitionResults" class="item2">{{ resultJson[item.code] }}</div>
              <auto-number-input
                v-model="job.chargeWeight"
                class="item3"
                :style="{ borderColor: getValueBorderColor(item) }"
                no="chargeWeight"
                :precision="3"
                :min="0"
                @valCallBack="(val)=>{
                  job.chargeWeight = val
                }"
              />
            </div>
            <!--Rate Charge-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_RATE_CHARGE.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ OcrUtils.getOcrFieldLabel(item.code, useCase) }}</div>
              <div v-if="showBookRecognitionResults" class="item2">{{ resultJson[item.code] }}</div>
              <div style="display: flex;justify-content: space-between" class="item3">
                <el-input v-model="job.airCargoDoc[0].rateCharge" class="item3" :style="{ borderColor: getValueBorderColor(item) }" />
              </div>
            </div>
            <!--Total-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_C_TOTAL.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ OcrUtils.getOcrFieldLabel(item.code, useCase) }}</div>
              <div v-if="showBookRecognitionResults" class="item2">{{ resultJson[item.code] }}</div>
              <div style="display: flex;justify-content: space-between" class="item3">
                <el-input v-model="job.airCargoDoc[0].cTotal" class="item3" :style="{ borderColor: getValueBorderColor(item) }" />
              </div>
            </div>
            <!--Dimension-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_DIMENSION.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ OcrUtils.getOcrFieldLabel(item.code, useCase) }}</div>
              <!--            <div class="item2" v-if="showBookRecognitionResults">{{ resultJson[item.code] }}</div>-->
              <el-input v-if="showBookRecognitionResults" v-model="resultJson[item.code]" disabled :rows="6" type="textarea" class="item2" />
              <el-input v-model="job.airCargoDoc[0].dimension" :rows="6" type="textarea" :style="{borderColor: getValueBorderColor(item)}" class="item3" no="dimension" />
            </div>
            <!--Currency-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_CURRENCY.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ OcrUtils.getOcrFieldLabel(item.code, useCase) }}</div>
              <div v-if="showBookRecognitionResults" class="item2">{{ resultJson[item.code] }}</div>
              <cargo-advance-select
                class="item3"
                :style="{ borderColor: getValueBorderColor(item) }"
                no="currency"
                :select-type="selectTypeNames.basic_data_Currency"
                filterable
                :default-value="job.airCargoDoc[0].currency"
                :placeholder="!job.airCargoDoc[0].currency && resultJson[item.code] && !resultJson[item.code + '_notShowPlaceholder'] ? resultJson[item.code] : ''"
                :class="!job.airCargoDoc[0].currency && resultJson[item.code] && !resultJson[item.code + '_notShowPlaceholder'] ? 'color-red' : ''"
                @clear="clear(item)"
                @parentCallBack="p=>{job.airCargoDoc[0].currency=p.value}"
              />
            </div>
            <!--WT/VAL-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_WT_VAL.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ OcrUtils.getOcrFieldLabel(item.code, useCase) }}</div>
              <div v-if="showBookRecognitionResults" class="item2">{{ resultJson[item.code] }}</div>
              <el-select v-model="job.airCargoDoc[0].wtVal" class="item3" no="wtVal" :style="{ borderColor: getValueBorderColor(item) }">
                <el-option label="PP" value="PP" />
                <el-option label="CC" value="CC" />
              </el-select>
            </div>
            <!--Signature of Shipper or his Agent-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_SIGN_BY_SHIPPER.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ OcrUtils.getOcrFieldLabel(item.code, useCase) }}</div>
              <div v-if="showBookRecognitionResults" class="item2">{{ resultJson[item.code] }}</div>
              <div style="display: flex;justify-content: space-between" class="item3">
                <el-input v-model="job.airCargoDoc[0].signByShipper" class="item3" :style="{ borderColor: getValueBorderColor(item) }" />
              </div>
            </div>
            <!--备注-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_REMARKS.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ OcrUtils.getOcrFieldLabel(item.code, useCase) }}</div>
              <div v-if="showBookRecognitionResults" class="item2">{{ resultJson[item.code] }}</div>
              <el-input v-model="job.remarks" :rows="6" type="textarea" class="item3" :style="{ borderColor: getValueBorderColor(item) }" no="remarks" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import { CONTAINERLOAD_TYPES } from '@/class/cargo/model/parameters/ContainerLoadType'
import CargoPackingSelect from '@/components/Cargo/Common/cargoPackingSelect'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import CargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput'
import CargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import ColumnUtils from '@/utils/ColumnUtils'
import { getOcrList } from '@/api/ocrSet'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import StrUtils from '@/utils/StrUtils'
import { deepClone } from '@/utils'
import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import {
  AI, FIELD_PREFIX_CARGO_DOC,
  FIELD_PREFIX_TRUCKING, INTELLIGENT_DOCUMENT_SOURCE_13,
  OCR_FIELD_IF_REQUIRED_SAVE_JOB,
  OCR_FIELD_MAP,
  SENDING_5,
  UPLOAD_STATUS_COMPLETE_ORDER
} from '@/class/cargo/model/parameters/SystemConstants'
import cargoOfficeSelect from '@/components/Cargo/Common/cargoOfficeSelect'
import cargoDepartmentSelect from '@/components/Cargo/Common/cargoDepartmentSelect'
import { Company } from '@/class/model/mdm/Company'
import shippingScheduleDialog from '@/components/Cargo/Job/shippingScheduleDialog.vue'
import { BookingWorkspaceContext } from '@/views/cargo/v0/SeaExport/components/booking/bookingWorkspaceContext'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { getAirlineList } from '@/api/partner/airline'
import { handleBlur } from '@/utils/commonUtil'
import OcrUtils from '@/utils/OcrUtils'
import { AirExportJob } from '@/class/model/booking/AirExportJob'
import { AirImportJob } from '@/class/model/booking/AirImportJob'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import { cache, cacheName } from '@/utils/cacheManager'
import * as AirExportConstants from '@/class/cargo/model/parameters/AirExportConstants'
import DateUtils from '@/utils/dateUtils'
import { ImportConstants } from '@/class/cargo/model/utils/ImportConstants'

export default {
  name: 'ResultFormAi',
  components: { CargoRichTextarea, AutoNumberInput, CargoUserSelect, CargoAdvanceSelect,
    CargoPackingSelect, cargoCompanySelect, cargoOfficeSelect, cargoDepartmentSelect, shippingScheduleDialog },
  props: {
    details: {
      type: Object,
      default: () => ({})
    },
    index: { type: Number, default: 0 },
    resultArray: { type: Array, default: () => [] },
    source: { // 来源【0-海出 1-远程订舱-海运】
      type: Number,
      default: () => INTELLIGENT_DOCUMENT_SOURCE_13.code
    }
  },
  data() {
    return {
      handleBlur, OcrUtils, AirExportConstants,
      context: new BookingWorkspaceContext(),
      CargoSource,
      JobUtils,
      resultJson: {},
      containerLoadTypes: CONTAINERLOAD_TYPES,
      SystemConstants,
      ColumnUtils,
      selectTypeNames: TYPE_NAMES,
      useCase: SENDING_5.code, // 0 海运出口 1 空运出口
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        successCallback: null,
        isUppercase: false,
        formatObj: {
          warningCount: -1,
          maxChar: 0,
          autoHalfWord: false,
          autoUppercase: false
        }
      },
      expressList: [],
      mapperTexts: [],
      port: new Map(),
      carrier: new Map(),
      orderType: new Map(),
      loadType: new Map(),
      shippingTerm: new Map(),
      paymentTerm: new Map(),
      incoTerm: new Map(),
      customer: new Map(),
      packing: new Map(),
      job: new AirExportJob().fillDefaultValue().getData(),
      paymentTermMBL: null,
      OCR_FIELD_MAP,
      otherField: null,
      ocrRecognitionFields: [], // ocr识别字段
      ocrOtherFields: [], // 额外录单字段
      currentOcrRecognitionFields: [], // 当前 ocr识别字段
      currentOcrOtherFields: [], // 当前 额外录单字段
      fieldDefineMap: {}, // 字段定义
      firstEntry: true, // 首次进入时，字段、value框的颜色为默认值
      showBookRecognitionResults: false, // 展示托书识别结果
      visible: false, // 初始化完毕再展示当前数据，避免用户感知弹窗数据变化
      aEcWeightCeil: ''
    }
  },
  computed: {
    readOnly() {
      return this.details && this.details.status === 3
    },
    showOtherField() {
      return this.expressList && this.expressList.length > 0
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    config() {
      return this.context.config
    }
  },
  watch: {
    details(val, oldVal) {
      if (val.resultJson !== oldVal.resultJson) {
        this.init()
      }
    },
    index(val, oldVal) {
      if (val !== oldVal) {
        this.resultJson = this.resultArray[val].text.data
        this.job = this.resultJson.jobJson
        this.setDefaultValue()
        this.paymentTermMBL = this.job.paymentTermMBL
      }
    }
  },
  async created() {
    await this.context.prepareData()
    await cache.load(cacheName.CONFIG)
    this.aEcWeightCeil = Number(cache.config.get('AEcWeightCeil'))
    await this.init()
  },
  methods: {
    handleFocus(val) {
      this.$emit('fieldFocus', val)
    },
    async init() {
      await this.initOcrSet()
      // 【已录单】的托书，字段展示历史的
      if (this.details.status === UPLOAD_STATUS_COMPLETE_ORDER.code && this.resultArray[0].ocrRecognitionFields && this.resultArray[0].ocrRecognitionFields.length > 0) {
        this.currentOcrRecognitionFields = this.resultArray[0].ocrRecognitionFields
        this.currentOcrOtherFields = this.resultArray[0].ocrOtherFields
      } else {
        this.currentOcrRecognitionFields = this.ocrRecognitionFields
        this.currentOcrOtherFields = this.ocrOtherFields
      }
      // this.initOther()
      for (let i = 0; i < this.resultArray.length; ++i) {
        const result = this.resultArray[i]
        const resultJson = result.text.data
        const emailResultJson = result.emailText ? result.emailText.data : {}
        const finalResultJson = OcrUtils.getFinalResultJson(resultJson, emailResultJson, this.otherField, this.fieldDefineMap)
        // 将json信息转换成对应的值
        if (!resultJson.jobJson) {
          // 尝试新方式
          // resultJson.jobJson = deepClone(this.initJob)
          resultJson.jobJson = new AirExportJob().fillDefaultValue().getData()
          resultJson.jobJson.airCargoDoc = [await new AirImportJob(resultJson.jobJson).getCargoDoc(CargoDocConsts.HAWB, true)]
          resultJson.jobJson.index = i
          // trucking 赋值
          for (const key in finalResultJson) {
            if (key.startsWith(FIELD_PREFIX_CARGO_DOC)) {
              resultJson.jobJson.airCargoDoc[0][key.replace(FIELD_PREFIX_CARGO_DOC, '')] = finalResultJson[key]
              delete finalResultJson[key]
            }
          }
          // 将finalResultJson赋值给jobJson
          Object.assign(resultJson.jobJson, finalResultJson)
          await this.initJobJson(resultJson.jobJson, finalResultJson)
          this.job = resultJson.jobJson
          // 初始化时，备份jobJson，用于统计准确率（业务保存成功，异步进行统计）
          resultJson.originJobJson = deepClone(resultJson.jobJson)
        } else {
          resultJson.jobJson.index = i
          this.job = resultJson.jobJson
        }
      }
      setTimeout(() => {
        this.resultJson = this.resultArray[this.index].text.data
        this.job = this.resultJson.jobJson
        this.visible = true
        this.paymentTermMBL = this.job.paymentTermMBL
        this.setDefaultValue()
        this.firstEntry = false
      }, 100)
    },
    setDefaultValue() {
      if (!this.job.copyNumber) {
        this.job.copyNumber = 1
      }
      let hasBusinessMark = false
      if (this.currentOcrOtherFields && this.currentOcrOtherFields.length > 0) {
        for (const item of this.currentOcrOtherFields) {
          if (item && item.code === SystemConstants.BUSINESS_MARK.code) {
            hasBusinessMark = true
            break
          }
        }
      }
      if (hasBusinessMark) {
        if (!this.job.businessMark || this.job.businessMark.length === 0) {
          this.job.businessMark = [0]
        }
      } else {
        this.job.businessMark = []
      }
    },
    async initJobJson(job, resultJson) {
      this.convertMapper(job, resultJson)

      // 件数
      const quantityActual = this.changeValue(resultJson, 'quantityActual', ['CASE', 'PKGS', 'CTNS'])
      if (quantityActual !== 0) {
        job.quantityActual = Number(!StrUtils.isEmpty(job.packing) && typeof quantityActual === 'string' ? quantityActual.replace(job.packing, '') : quantityActual)
      }
      // 毛重
      const weightActual = this.changeValue(resultJson, 'weightActual', ['KGS', this.$t('SeaExport.KG'), ','])
      job.weightActual = Number(weightActual)
      // 体积
      const cubageActual = this.changeValue(resultJson, 'cubageActual', ['CBM', this.$t('SeaExport.CBM')])
      job.cubageActual = Number(cubageActual)

      // 初始化 操作公司(一定要放在操作部门赋值前面，因为操作部门会根据操作分公司去查)
      job.opOffice = this.$store.getters.currentOfficeId
      job.lob = AI.code

      // 若是未识别到，需要自动计算显示计费重量（与现有空运计算计费重量规则保持一致）
      if (!job.chargeWeight) {
        const chargeWeight = job.cubageActual / 0.006
        let value = ''
        if (chargeWeight > job.weightActual) {
          value = ImportConstants.toFixed2(chargeWeight, 1)
        } else {
          value = ImportConstants.toFixed2(job.weightActual, 1)
        }
        job.chargeWeight = Number(value)
      }
    },
    changeValue(job, targetField, replaceArr) {
      let result = 0
      if (!StrUtils.isEmpty(job[targetField])) {
        result = job[targetField]
        if (typeof result === 'string') {
          result = result.trim()
          for (const element of replaceArr) {
            result = result.replace(element, '')
          }
        }
      }
      return result
    },
    convertMapper(job, resultJson) {
      this.initMapper()
      // 委托单位
      OcrUtils.mapperCustomerId(job, resultJson, this, { customer: true, companyLob: 'airImport', active: true })
      // 航空公司
      OcrUtils.mapperAirlineCompany(job, resultJson, this, { airCmp: true, companyLob: 'airImport', active: true })
      // 开航日期
      OcrUtils.mapperDate('etd', job, resultJson, DateUtils.STANDARD_MINUTE_TIME)
      // 运费条款
      OcrUtils.mapperPaymentTerm(job, resultJson, this)
      // 贸易条款
      OcrUtils.mapperIncoTerm(job, resultJson, this)
      // 起始站
      OcrUtils.mapperPort('loadingPortCode', 'loadingPortCode', job, resultJson, this, TYPE_NAMES.basic_data_Airport)
      // 目的站
      OcrUtils.mapperPort('dischargingPortCode', 'dischargingPortCode', job, resultJson, this, TYPE_NAMES.basic_data_Airport)
      // 包装
      OcrUtils.mapperPacking('', job, resultJson, this)
      // 签发日期
      OcrUtils.mapperDate('signDateBL', job.airCargoDoc[0], resultJson, DateUtils.STANDARD_DATE)
      // 币种
      OcrUtils.mapperCurrency(job.airCargoDoc[0], resultJson)
      // 操作模式
      OcrUtils.mapperOperateType(job, resultJson)
    },
    showAdvanceTextDialog(title, value, successCallback, isUppercase = false, formatObject = null) {
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.isUppercase = isUppercase
      const defaultFormatObj = {
        warningCount: -1,
        maxChar: 0,
        autoHalfWord: false,
        autoUppercase: false
      }
      this.advanceTextDialog.formatObj = formatObject ? { ...defaultFormatObj, ...formatObject } : defaultFormatObj
      this.advanceTextDialog.visible = true
      this.$nextTick(() => {
        this.$refs.advanceTextDialogTextarea.editor.focus()
      })
    },
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    },
    closeAdvanceText() {
      this.advanceTextDialog.visible = false
    },
    // 获取OCR映射
    async initOcrSet() {
      const params = {
        branchId: this.$store.getters.currentOfficeId,
        anyInteger: this.useCase, // 应用场景 0海运出口托书识别
        anyBool: true // 应用场景 判断是否应用总部
      }
      await getOcrList(params).then(res => {
        const ocrSet = res.data
        if (ocrSet) {
          // 文字映射
          this.toMapperText(ocrSet)
          // 额外录单字段
          this.toOtherField(ocrSet)
        }
      })
    },
    // 文字映射
    toMapperText(ocrSet) {
      const mapperList = ocrSet.mapperList || []
      const mapperHqList = ocrSet.mapperHqList || []
      const otherMapper = mapperList.length > 0 ? mapperList[0] : null
      if (otherMapper && otherMapper.ifHq) {
        this.mapperTexts = mapperHqList
      }
      if (!this.mapperTexts || this.mapperTexts.length === 0) {
        this.mapperTexts = mapperList || []
      }
    },
    initMapper() {
      this.port = new Map()
      this.carrier = new Map()
      this.orderType = new Map()
      this.loadType = new Map()
      this.shippingTerm = new Map()
      this.paymentTerm = new Map()
      this.incoTerm = new Map()
      this.customer = new Map()
      this.packing = new Map()
      const mapperTexts = this.mapperTexts
      if (!mapperTexts || mapperTexts.length <= 0) {
        return
      }
      for (const mapperText of this.mapperTexts) {
        const mapperKey = mapperText.type + '_' + mapperText.useCase + '_' + mapperText.oldText
        const mapperVal = mapperText.newText
        if (mapperText.type === SystemConstants.OCR_MAPPER_TYPE_PORT.code) {
          this.port.set(mapperKey, mapperVal)
        } else if (mapperText.type === SystemConstants.OCR_MAPPER_TYPE_CARRIER.code) {
          this.carrier.set(mapperKey, mapperVal)
        } else if (mapperText.type === SystemConstants.OCR_MAPPER_TYPE_BL_TYPE.code) {
          this.orderType.set(mapperKey, mapperVal)
        } else if (mapperText.type === SystemConstants.OCR_MAPPER_TYPE_LOAD_TYPE.code) {
          this.loadType.set(mapperKey, mapperVal)
        } else if (mapperText.type === SystemConstants.OCR_MAPPER_TYPE_SHIPPING_TERM.code) {
          this.shippingTerm.set(mapperKey, mapperVal)
        } else if (mapperText.type === SystemConstants.OCR_MAPPER_TYPE_PAYMENT_TERM.code) {
          this.paymentTerm.set(mapperKey, mapperVal)
        } else if (mapperText.type === SystemConstants.OCR_MAPPER_TYPE_INCO_TERM.code) {
          this.incoTerm.set(mapperKey, mapperVal)
        } else if (mapperText.type === SystemConstants.OCR_MAPPER_TYPE_CUSTOMER.code) {
          this.customer.set(mapperKey, mapperVal)
        } else if (mapperText.type === SystemConstants.OCR_MAPPER_TYPE_PACKING.code) {
          this.packing.set(mapperKey, mapperVal)
        }
      }
    },
    // 额外录单字段
    toOtherField(ocrSet) {
      this.otherField = ocrSet.finalField

      this.fieldDefineMap = ocrSet.fieldDefineMap
      if (this.otherField.ocrOtherFieldDetails) {
        // ocr识别字段
        this.ocrRecognitionFields = this.otherField.ocrOtherFieldDetails.filter(item => {
          return this.fieldDefineMap[item.code] && !this.fieldDefineMap[item.code].ifExtraField
        })
        // 额外录单字段
        this.ocrOtherFields = this.otherField.ocrOtherFieldDetails.filter(item => this.fieldDefineMap[item.code] && this.fieldDefineMap[item.code].ifExtraField)
      }
    },
    etdChange(value) {
      this.job.etd = value && value.length === 16 ? value + ':00' : value
      this.job.sailingDay = JobUtils.dateChange(this.job.etd)
    },
    // 保存时获取数据
    getSubmitData() {
      const result = this.resultJson
      result.jobJson = this.job
      return result
    },
    getFieldColor(item) {
      if (!this.firstEntry && item.ifCheck && item.ifRequired) {
        if (item.ifRequired.split(',').length > 1 || item.ifRequired === OCR_FIELD_IF_REQUIRED_SAVE_JOB.code) {
          return '#1398f1'
        }
      }
      return '#8c8d8e'
    },
    getValueBorderColor(item) {
      if (!this.firstEntry && item.ifCheck && item.ifRequired) {
        if (item.ifRequired.split(',').length > 1 || item.ifRequired === OCR_FIELD_IF_REQUIRED_SAVE_JOB.code) {
          if (!this.job[item.code] || (Array.isArray(this.job[item.code]) && this.job[item.code].length === 0)) {
            return 'red'
          }
        }
      }
      return this.fieldDefineMap[item.code] && this.fieldDefineMap[item.code].ifExtraField ? 'white' : '#cee0c8'
    },
    clear(item) {
      this.resultJson[item.code + '_notShowPlaceholder'] = true
      this.$forceUpdate()
    },
    async voyageFlightCheckHandler() {
      if (this.job.voyageFlight) {
        this.job.voyageFlight = this.job.voyageFlight.trim().toUpperCase()
        const voyageFlight = this.job.voyageFlight
        const airline = await this.getPartnerAirline(this.job.carrierId)
        const airlineCode = airline.airlineCode.trim()
        if (airlineCode && airlineCode !== voyageFlight.substring(0, 2)) {
          this.$message.warning(this.$t('queryJob.EnteredXNotMatchAirlineCode', [voyageFlight]))
        }
      }
    },
    // 获取合作伙伴航空公司信息
    async getPartnerAirline(cmpIdx) {
      const airline = { cmpIdx, airlineCode: '', mawbprefix: '' }
      const cmp = Company.getCompanyByIdSync(cmpIdx)
      if (cmp) {
        await getAirlineList({ companyUuid: cmp.uuid }).then(res => {
          if (res.data.list.length > 0) {
            Object.assign(airline, res.data.list[0])
          }
        })
      }
      return airline
    },
    setJobSelectValue(obj) {
      this.job[obj.key] = obj.value
    }
  }
}
</script>

<style lang="scss" scoped>
.result-form-ai {
  display: flex;
  .row {
    display: flex;
    align-items: stretch
  }
  .item1 {
    min-width: 185px;
    border: 1px solid white;
    background-color: #e9edf1;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 28px;
  }
  .item2 {
    width: 100%;
    min-width: 100px;
    border: 1px solid white;
    background-color: #f7f7f7;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 28px;
    pointer-events: none;
  }
  .item3 {
    width: 100%;
    border: 1px solid #cee0c8;
    background-color: #cee0c8;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 28px;
    /deep/ input.el-input__inner {
      background-color: #cee0c8;
      text-align: left;
    }
    .item3-1 /deep/ input.el-input__inner {
      background-color: white;
    }
    /deep/ .el-textarea__inner {
      background-color: #cee0c8;
    }
  }
  .item4 {
    width: 100%;
    border: 1px solid white;
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 28px;
    /deep/ input.el-input__inner {
      background-color: white;
    }
    /deep/ .el-textarea__inner {
      background-color: white;
    }
  }
  .color-yellow {
    /deep/ textarea.el-textarea__inner {
      color: #e36402;
    }
  }
  .is-require {
    color: #4abff3;
  }
  .color-red {
    /deep/ input::placeholder{
      color: red !important;
    }
  }
}
</style>
